import { FormInstance } from "antd/es/form";
import React from "react";
import { IValidationData } from "../../models/dto/validation-data";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";
import { Header2_ScreenContext } from "../header2/header2-context";

declare let window: any;

export interface IBasketReportsDetail_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface IBasketReportsDetail_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  BasketReportsDetailHeader: any[];
  BasketReportsDetailHeader_dummy: any[];
  BasketReportsDetail: any[];
  BasketReportsDetail_dummy: any[];
  BasketLineDeleted: any[];
  BasketLineDeleted_dummy: any[];
  Notify: boolean;
  Notify_dummy: boolean;
  isComp863396Visible: "visible" | "hidden";
  isComp552132Visible: "visible" | "hidden";
  isComp156358Visible: "visible" | "hidden";
  isComp312626Visible: "visible" | "hidden";
  isComp59423Visible: "visible" | "hidden";
  isComp833910Visible: "visible" | "hidden";
  isComp616664Visible: "visible" | "hidden";
  isComp895578Visible: "visible" | "hidden";
  isComp228062Visible: "visible" | "hidden";
  isComp814673Visible: "visible" | "hidden";
}

export class BasketReportsDetail_ScreenBase extends React.PureComponent<
  IBasketReportsDetail_ScreenProps,
  any
> {
  static contextType = Header2_ScreenContext;
  declare context: React.ContextType<typeof Header2_ScreenContext>;
  basketreportsdetail_726527_value_kuikaTableRef: React.RefObject<any>;
  ml = [
    {
      Id: "70da2015-72e4-4a73-bc3e-b700175ae3a3",
      Name: "en_US",
      ShortName: "English",
      IsDefault: true,
      LanguagePhrases: [],
    },
    {
      Id: "e68c2ddf-a7b3-425c-95db-e3ce5d1117a3",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        { Id: 312626, PropertyName: "value", Value: "Aktif" },
        { Id: 59423, PropertyName: "value", Value: "Tamamlandı" },
        { Id: 833910, PropertyName: "value", Value: "İptal Edildi" },
        { Id: 138911, PropertyName: "value", Value: "Müşteri Bilgileri" },
        { Id: 29555, PropertyName: "value", Value: "Satış Personeli" },
        { Id: 410086, PropertyName: "value", Value: "Sepetteki Ürün Adedi" },
        { Id: 918913, PropertyName: "title", Value: "Title" },
        { Id: 656472, PropertyName: "value", Value: "[datafield:productcode]" },
        {
          Id: 508039,
          PropertyName: "value",
          Value: "[datafield:productdescription]",
        },
        { Id: 381062, PropertyName: "value", Value: "[datafield:quantity]" },
        { Id: 286558, PropertyName: "value", Value: "Adet" },
        { Id: 895578, PropertyName: "value", Value: "Stokta" },
        { Id: 228062, PropertyName: "value", Value: "Stokta Yok" },
        { Id: 481673, PropertyName: "value", Value: "Ekleyen Satış Personeli" },
        {
          Id: 250873,
          PropertyName: "value",
          Value: "[datafield:salespersoncode]",
        },
        {
          Id: 992803,
          PropertyName: "value",
          Value: "[datafield:salespersonname]",
        },
        { Id: 814673, PropertyName: "value", Value: "[datafield:totalprice]" },
      ],
    },
  ];
  defaultML = "en_US";

  screenHash = "";

  private _prevMasterPageInitLoaded: boolean = false;
  private _prevMasterPageRecurringLoaded: boolean = false;
  private _prevShouldTriggerPageInit: boolean = false;
  constructor(props) {
    super(props);
    this.basketreportsdetail_726527_value_kuikaTableRef = React.createRef();

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      BasketReportsDetailHeader: [],
      BasketReportsDetail: [],
      BasketLineDeleted: [],
      Notify: false,
      isComp863396Visible: "hidden",
      isComp552132Visible: "hidden",
      isComp156358Visible: "hidden",
      isComp312626Visible: "hidden",
      isComp59423Visible: "hidden",
      isComp833910Visible: "hidden",
      isComp616664Visible: "hidden",
      isComp895578Visible: "hidden",
      isComp228062Visible: "hidden",
      isComp814673Visible: "hidden",
    };

    this.state.isPageVisible = true;
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight(
        "basketreportsdetail",
        "header2_screen"
      );
      return;
    }
    this.context.registerCallbackFunction(this.callCallbackFunction.bind(this));

    ReactSystemFunctions.validateToken();
    this.fillFormInitValues();
    if (false) {
      await this.BasketReportsDetailPageInit();
    } else if (this.context?.isMasterPageInitLoaded) {
      this._prevMasterPageInitLoaded = true;
      await this.BasketReportsDetailPageInit();
    }

    KuikaAppManager.calculateAndSetBodyHeight(
      "basketreportsdetail",
      "header2_screen"
    );

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight(
      "basketreportsdetail",
      "header2_screen"
    );
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.BasketReportsDetailPageInit();
    }

    if (
      this._prevMasterPageInitLoaded !== this.context.isMasterPageInitLoaded &&
      this.context.isMasterPageInitLoaded === true
    ) {
      this._prevMasterPageInitLoaded = this.context.isMasterPageInitLoaded;
      await this.BasketReportsDetailPageInit();
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({});
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  BasketReportsDetailPageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      CartHeaderId_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.CartHeaderId ??
          this.props.screenInputs.cartheaderid,
        "Guid"
      ),
      CartHeaderId_1: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.CartHeaderId ??
          this.props.screenInputs.cartheaderid,
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "BasketReportsDetail/BasketReportsDetailPageInit",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.BasketReportsDetailHeader =
      result?.data.basketReportsDetailHeader;
    formVars.basketreportsdetail_271590_value = ReactSystemFunctions.value(
      this,
      stateVars.BasketReportsDetailHeader !== undefined
        ? stateVars.BasketReportsDetailHeader?.length > 0
          ? stateVars.BasketReportsDetailHeader[0].createdAt
          : null
        : this.state.BasketReportsDetailHeader?.length > 0
        ? this.state.BasketReportsDetailHeader[0].createdAt
        : null
    );
    formVars.basketreportsdetail_389229_value = ReactSystemFunctions.toString(
      this,
      stateVars.BasketReportsDetailHeader !== undefined
        ? stateVars.BasketReportsDetailHeader?.length > 0
          ? stateVars.BasketReportsDetailHeader[0].curAccCode
          : null
        : this.state.BasketReportsDetailHeader?.length > 0
        ? this.state.BasketReportsDetailHeader[0].curAccCode
        : null
    );
    formVars.basketreportsdetail_813071_value = ReactSystemFunctions.toString(
      this,
      stateVars.BasketReportsDetailHeader !== undefined
        ? stateVars.BasketReportsDetailHeader?.length > 0
          ? stateVars.BasketReportsDetailHeader[0].customerName
          : null
        : this.state.BasketReportsDetailHeader?.length > 0
        ? this.state.BasketReportsDetailHeader[0].customerName
        : null
    );
    formVars.basketreportsdetail_510541_value = ReactSystemFunctions.toString(
      this,
      stateVars.BasketReportsDetailHeader !== undefined
        ? stateVars.BasketReportsDetailHeader?.length > 0
          ? stateVars.BasketReportsDetailHeader[0].salesPersonCode
          : null
        : this.state.BasketReportsDetailHeader?.length > 0
        ? this.state.BasketReportsDetailHeader[0].salesPersonCode
        : null
    );
    formVars.basketreportsdetail_212691_value = ReactSystemFunctions.toString(
      this,
      stateVars.BasketReportsDetailHeader !== undefined
        ? stateVars.BasketReportsDetailHeader?.length > 0
          ? stateVars.BasketReportsDetailHeader[0].salesPersonName
          : null
        : this.state.BasketReportsDetailHeader?.length > 0
        ? this.state.BasketReportsDetailHeader[0].salesPersonName
        : null
    );
    formVars.basketreportsdetail_315417_value = ReactSystemFunctions.toString(
      this,
      stateVars.BasketReportsDetailHeader !== undefined
        ? stateVars.BasketReportsDetailHeader?.length > 0
          ? stateVars.BasketReportsDetailHeader[0].totalQuantity
          : null
        : this.state.BasketReportsDetailHeader?.length > 0
        ? this.state.BasketReportsDetailHeader[0].totalQuantity
        : null
    );
    stateVars.isComp863396Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.BasketReportsDetailHeader !== undefined
            ? stateVars.BasketReportsDetailHeader?.length > 0
              ? stateVars.BasketReportsDetailHeader[0].statusType
              : null
            : this.state.BasketReportsDetailHeader?.length > 0
            ? this.state.BasketReportsDetailHeader[0].statusType
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("1", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp552132Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.BasketReportsDetailHeader !== undefined
            ? stateVars.BasketReportsDetailHeader?.length > 0
              ? stateVars.BasketReportsDetailHeader[0].statusType
              : null
            : this.state.BasketReportsDetailHeader?.length > 0
            ? this.state.BasketReportsDetailHeader[0].statusType
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("2", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp156358Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.BasketReportsDetailHeader !== undefined
            ? stateVars.BasketReportsDetailHeader?.length > 0
              ? stateVars.BasketReportsDetailHeader[0].statusType
              : null
            : this.state.BasketReportsDetailHeader?.length > 0
            ? this.state.BasketReportsDetailHeader[0].statusType
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("3", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp312626Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.BasketReportsDetailHeader !== undefined
            ? stateVars.BasketReportsDetailHeader?.length > 0
              ? stateVars.BasketReportsDetailHeader[0].statusType
              : null
            : this.state.BasketReportsDetailHeader?.length > 0
            ? this.state.BasketReportsDetailHeader[0].statusType
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("1", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp59423Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.BasketReportsDetailHeader !== undefined
            ? stateVars.BasketReportsDetailHeader?.length > 0
              ? stateVars.BasketReportsDetailHeader[0].statusType
              : null
            : this.state.BasketReportsDetailHeader?.length > 0
            ? this.state.BasketReportsDetailHeader[0].statusType
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("2", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp833910Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.BasketReportsDetailHeader !== undefined
            ? stateVars.BasketReportsDetailHeader?.length > 0
              ? stateVars.BasketReportsDetailHeader[0].statusType
              : null
            : this.state.BasketReportsDetailHeader?.length > 0
            ? this.state.BasketReportsDetailHeader[0].statusType
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("3", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.BasketReportsDetail = result?.data.basketReportsDetail;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.BasketReportsDetailPageInit1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  BasketReportsDetailPageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.isComp863396Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.BasketReportsDetailHeader !== undefined
            ? stateVars.BasketReportsDetailHeader?.length > 0
              ? stateVars.BasketReportsDetailHeader[0].statusType
              : null
            : this.state.BasketReportsDetailHeader?.length > 0
            ? this.state.BasketReportsDetailHeader[0].statusType
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("1", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp552132Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.BasketReportsDetailHeader !== undefined
            ? stateVars.BasketReportsDetailHeader?.length > 0
              ? stateVars.BasketReportsDetailHeader[0].statusType
              : null
            : this.state.BasketReportsDetailHeader?.length > 0
            ? this.state.BasketReportsDetailHeader[0].statusType
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("2", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp156358Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.BasketReportsDetailHeader !== undefined
            ? stateVars.BasketReportsDetailHeader?.length > 0
              ? stateVars.BasketReportsDetailHeader[0].statusType
              : null
            : this.state.BasketReportsDetailHeader?.length > 0
            ? this.state.BasketReportsDetailHeader[0].statusType
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("3", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp312626Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.BasketReportsDetailHeader !== undefined
            ? stateVars.BasketReportsDetailHeader?.length > 0
              ? stateVars.BasketReportsDetailHeader[0].statusType
              : null
            : this.state.BasketReportsDetailHeader?.length > 0
            ? this.state.BasketReportsDetailHeader[0].statusType
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("1", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp59423Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.BasketReportsDetailHeader !== undefined
            ? stateVars.BasketReportsDetailHeader?.length > 0
              ? stateVars.BasketReportsDetailHeader[0].statusType
              : null
            : this.state.BasketReportsDetailHeader?.length > 0
            ? this.state.BasketReportsDetailHeader[0].statusType
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("2", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp833910Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.BasketReportsDetailHeader !== undefined
            ? stateVars.BasketReportsDetailHeader?.length > 0
              ? stateVars.BasketReportsDetailHeader[0].statusType
              : null
            : this.state.BasketReportsDetailHeader?.length > 0
            ? this.state.BasketReportsDetailHeader[0].statusType
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("3", "string")
      ) === true
        ? "visible"
        : "hidden";
    formVars.basketreportsdetail_271590_value = ReactSystemFunctions.value(
      this,
      stateVars.BasketReportsDetailHeader !== undefined
        ? stateVars.BasketReportsDetailHeader?.length > 0
          ? stateVars.BasketReportsDetailHeader[0].createdAt
          : null
        : this.state.BasketReportsDetailHeader?.length > 0
        ? this.state.BasketReportsDetailHeader[0].createdAt
        : null
    );

    formVars.basketreportsdetail_389229_value = ReactSystemFunctions.toString(
      this,
      stateVars.BasketReportsDetailHeader !== undefined
        ? stateVars.BasketReportsDetailHeader?.length > 0
          ? stateVars.BasketReportsDetailHeader[0].curAccCode
          : null
        : this.state.BasketReportsDetailHeader?.length > 0
        ? this.state.BasketReportsDetailHeader[0].curAccCode
        : null
    );

    formVars.basketreportsdetail_813071_value = ReactSystemFunctions.toString(
      this,
      stateVars.BasketReportsDetailHeader !== undefined
        ? stateVars.BasketReportsDetailHeader?.length > 0
          ? stateVars.BasketReportsDetailHeader[0].customerName
          : null
        : this.state.BasketReportsDetailHeader?.length > 0
        ? this.state.BasketReportsDetailHeader[0].customerName
        : null
    );

    formVars.basketreportsdetail_510541_value = ReactSystemFunctions.toString(
      this,
      stateVars.BasketReportsDetailHeader !== undefined
        ? stateVars.BasketReportsDetailHeader?.length > 0
          ? stateVars.BasketReportsDetailHeader[0].salesPersonCode
          : null
        : this.state.BasketReportsDetailHeader?.length > 0
        ? this.state.BasketReportsDetailHeader[0].salesPersonCode
        : null
    );

    formVars.basketreportsdetail_212691_value = ReactSystemFunctions.toString(
      this,
      stateVars.BasketReportsDetailHeader !== undefined
        ? stateVars.BasketReportsDetailHeader?.length > 0
          ? stateVars.BasketReportsDetailHeader[0].salesPersonName
          : null
        : this.state.BasketReportsDetailHeader?.length > 0
        ? this.state.BasketReportsDetailHeader[0].salesPersonName
        : null
    );

    formVars.basketreportsdetail_315417_value = ReactSystemFunctions.toString(
      this,
      stateVars.BasketReportsDetailHeader !== undefined
        ? stateVars.BasketReportsDetailHeader?.length > 0
          ? stateVars.BasketReportsDetailHeader[0].totalQuantity
          : null
        : this.state.BasketReportsDetailHeader?.length > 0
        ? this.state.BasketReportsDetailHeader[0].totalQuantity
        : null
    );

    stateVars.dataSource_726527 =
      stateVars.BasketReportsDetail ?? this.state.BasketReportsDetail;
    stateVars.isComp895578Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          "basketreportsdetail_726527_value",
          "hasStock"
        ),
        ReactSystemFunctions.convertToTypeByName("1", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp228062Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          "basketreportsdetail_726527_value",
          "hasStock"
        ),
        ReactSystemFunctions.convertToTypeByName("0", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp814673Visible =
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.value(
          this,
          "basketreportsdetail_726527_value",
          "totalPrice"
        ),
        ReactSystemFunctions.convertToTypeByName("0", "string")
      ) === true
        ? "visible"
        : "hidden";

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  BasketReportsDetailComponent_470488_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      CartLineId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          "basketreportsdetail_726527_value",
          "cartLineId"
        ),
        "Guid"
      ),
      KUserId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.getMyUserId(),
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "BasketReportsDetail/BasketReportsDetailComponent_470488_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.BasketLineDeleted = result?.data.basketLineDeleted;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.BasketReportsDetailComponent_470488_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  BasketReportsDetailComponent_470488_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.Notify = await ReactSystemFunctions.notify(
      this,
      ReactSystemFunctions.toString(
        this,
        stateVars.BasketLineDeleted !== undefined
          ? stateVars.BasketLineDeleted?.length > 0
            ? stateVars.BasketLineDeleted[0].message
            : null
          : this.state.BasketLineDeleted?.length > 0
          ? this.state.BasketLineDeleted[0].message
          : null
      ),
      ReactSystemFunctions.convertToTypeByName("default", "string"),
      ReactSystemFunctions.convertToTypeByName("top", "string"),
      2,
      ReactSystemFunctions.convertToTypeByName("", "string"),
      ReactSystemFunctions.convertToTypeByName("", "string"),
      0
    );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.BasketReportsDetailComponent_470488_onClick2_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  BasketReportsDetailComponent_470488_onClick2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      CartHeaderId_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.CartHeaderId ??
          this.props.screenInputs.cartheaderid,
        "Guid"
      ),
    };

    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.BasketLineDeleted !== undefined
            ? stateVars.BasketLineDeleted?.length > 0
              ? stateVars.BasketLineDeleted[0].success
              : null
            : this.state.BasketLineDeleted?.length > 0
            ? this.state.BasketLineDeleted[0].success
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      )
    ) {
      if (true) {
        KuikaAppManager.showSpinner(this);
      }
      let result = await KuikaAppManager.ApiRequest(
        this,
        "BasketReportsDetail/BasketReportsDetailComponent_470488_onClick2_",
        localVar
      );
      if (!KMainFunctions.IsResStatus2XX(result)) return true;

      stateVars.BasketReportsDetail = result?.data.basketReportsDetail;

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.BasketReportsDetailComponent_470488_onClick3_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.BasketReportsDetailComponent_470488_onClick3_();
          resolve();
        });
      });
    }

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  BasketReportsDetailComponent_470488_onClick3_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.BasketLineDeleted !== undefined
            ? stateVars.BasketLineDeleted?.length > 0
              ? stateVars.BasketLineDeleted[0].success
              : null
            : this.state.BasketLineDeleted?.length > 0
            ? this.state.BasketLineDeleted[0].success
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      )
    ) {
      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.BasketReportsDetailComponent_470488_onClick4_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.BasketReportsDetailComponent_470488_onClick4_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  BasketReportsDetailComponent_470488_onClick4_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.BasketLineDeleted !== undefined
            ? stateVars.BasketLineDeleted?.length > 0
              ? stateVars.BasketLineDeleted[0].success
              : null
            : this.state.BasketLineDeleted?.length > 0
            ? this.state.BasketLineDeleted[0].success
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      )
    ) {
      stateVars.dataSource_726527 =
        stateVars.BasketReportsDetail ?? this.state.BasketReportsDetail;

      this.props.form?.setFieldsValue(formVars);
      this.setState(stateVars);
      KuikaAppManager.hideSpinner(this);
    } else {
      KuikaAppManager.hideSpinner(this);
    }

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
    let pageInitCallerNavDiIDs = [] as number[];
    if (isFromMaster || pageInitCallerNavDiIDs.indexOf(diId) > -1) {
      await this.BasketReportsDetailPageInit();
    }
  }
}
